import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuNL from "../../components/nl/MenuNL";
import FooterNL from "../../components/nl/FooterNL";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Frank Coel – Advocaat in Mechelen"}
                    description={"Advocaat in administratief recht, bestuursrecht, burgerlijk recht en strafrecht. Fusies, overnames en liquidaties en geschillen tussen vennoten."}
                    url={"https://www.coeladvocaten.be/nl/frank-coel"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/frank-coel", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/frank-coel", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/frank-coel", language:"en" }
                    ]}
                />

                <MenuNL
                    switchUrlFR="/fr/frank-coel"
                    switchUrlEN="/en/frank-coel"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-team"></div>
                        <div className="slider">
                            <h1>Ons team</h1>
                            <h2>Frank Coel</h2>
                            <p></p>
                            <a href="/nl/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <div className="image">
                                                <img className="img-fluid grayscale team-image-opacity" src="/static/images/ons-team-frank.jpg" width="100%" height="auto" /> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Frank Coel is gespecialiseerd in de verdediging van de rechten van particulieren en bedrijven, in het bijzonder tegenover overheden. Als advocaat verdedigt hij zowel op vlak van administratief recht, bestuursrecht, burgerlijk recht en strafrecht. Bovendien is hij deskundig in fusies, overnames en liquidaties en bemiddelaar bij geschillen tussen vennoten.</p>
                                            <p></p>
                                            <p><b>Specialiteiten</b></p>
                                            <p>
                                                <ul>
                                                    <li><b>Administratief recht:</b> verdediging van particulieren en bedrijven tegenover beslissingen van overheidsinstanties, op eender welk niveau. Van een vereenvoudigde herzieningsprocedure tot een beroep bij de Raad van State.</li>
                                                    <li><b>Ambtenarenrecht:</b> benoemingsprocedures, afzettingen en ontslagen van statutair en contractueel personeel.</li>
                                                    <li><b>Strafrecht:</b> verdediging van beklaagden en slachtoffers voor de politierechtbank en de rechtbank van eerste aanleg tot het Hof van Cassatie.</li>
                                                    <li><b>Bedrijfsrecht:</b> fusies, overnames, reorganisaties, liquidaties, geschillen tussen vennoten.</li>
                                                    <li><b>Burgerlijk recht:</b> landbouwpacht, erfpacht, erfdienstbaarheid, (commerciële) huurovereenkomsten, en beroep tegen onteigeningen.</li>
                                                </ul>
                                            </p>
                                            <p><b>Studies en opleidingen</b></p>
                                            <p>Licentiaat in de Rechten– Vrije Universiteit Brussel – 1990</p>
                                            <p>Stage in de advocatuur bij Feremans, Vets & Verreydt in Mechelen</p>
                                            <p>Getuigschrift van opleiding Cassatie in strafzaken – 2016</p>
                                            <p><b>Activiteiten</b></p>
                                            <p>
                                                <ul>
                                                    <li>Lid van de Balie Mechelen, daarna de Balie Provincie Antwerpen, sinds 1990</li>
                                                    <li>Lid van de Raad en penningmeester bij de Orde van Advocaten Mechelen tot 2019</li>
                                                    <li>Lid van diverse commissies bij de Orde van Vlaamse Balies</li>
                                                    <li>Lid van de Tuchtraad in Beroep sinds 2019 </li>
                                                    <li>Provincieraadslid bij de Provincie Antwerpen van 2000 tot 2006</li>
                                                </ul>
                                            </p>

                                            {/* <p></p>
                                            <p>Contact</p>
                                            <p><i className="fa fa-envelope"></i>&nbsp;frank@coeladvocaten.be</p>
                                            <p><i className="fa fa-phone"></i>&nbsp;+32 15 41 76 36</p>
                                            <p>&nbsp;</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterNL />
            </Layout>
        );
    }
}

export default Index;
